<template>
    <div>
        <div class="btn-group">
            <button class="btn btn-white dropdown-toggle" data-bs-toggle="dropdown" type="button">{{ current.label }}</button>
            <ul class="dropdown-menu">
                <li :key="index" v-for="(item, index) in options">
                    <span class="dropdown-item" :class="{ active: current.value === item.value }" @click="select(item.value)">{{ item.label }}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup>
    const props = defineProps({
        modelValue: { required: true, type: [Number, String] },
        options: { required: true, type: Array }
    });

    const current = computed(() => {
        return props.options.find((item) => item.value === props.modelValue);
    });

    const emit = defineEmits(["update:modelValue"]);

    const select = (value) => {
        emit("update:modelValue", value);
    };
</script>
